import { Group, Progress, Text } from '@mantine/core';
import { RawAssetsUploadProgress } from '@/app/assets/components/upload/hooks/useFileUpload';

type UploadProgressProps = {
  uploadProgress: RawAssetsUploadProgress;
};

export function UploadProgress({ uploadProgress }: UploadProgressProps) {
  return (
    <Group>
      <Progress
        color='teal.7'
        value={uploadProgress.totalProgress * 100}
        size='lg'
        transitionDuration={200}
        flex={1}
      />
      <Text c='gray.6'>
        Uploading ({uploadProgress.filesFinished} out of{' '}
        {uploadProgress.totalFiles} uploaded)
      </Text>
    </Group>
  );
}
